import { createContext } from 'react'

const NavbarContext = createContext({ hideItems: [] })
export { NavbarContext }
